if (!customElements.get('incipit-bar-slider')) {
  class IncipitBarSlider extends HTMLElement {
    constructor() {
      super();
      this.slides = [];
      this.currentIndex = 0;
      this.timer = null;
      this.autoplayDelay = 5000;
      this.isAnimating = false;
      this.isPaused = false;
    }

    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-incipit-slide]'));

      if (this.slides.length === 0) return;

      this.autoplayDelay = parseInt(this.dataset.autoplay, 10) || 5000;

      // Initial state : premier slide actif
      this.slides[0].classList.add('is-active');

      // Si un seul slide, pas d'animation
      if (this.slides.length < 2) return;

      // Pause au hover (desktop uniquement, on évite le tactile)
      if (window.matchMedia('(hover: hover)').matches) {
        this.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
        this.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
      }

      // Pause quand l'onglet n'est pas visible (économie batterie/CPU)
      document.addEventListener('visibilitychange', this.handleVisibilityChange.bind(this));

      this.start();
    }

    disconnectedCallback() {
      this.stop();
      document.removeEventListener('visibilitychange', this.handleVisibilityChange.bind(this));
    }

    start() {
      this.stop();
      this.timer = setInterval(() => {
        if (!this.isPaused) this.next();
      }, this.autoplayDelay);
    }

    stop() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    handleMouseEnter() {
      this.isPaused = true;
    }

    handleMouseLeave() {
      this.isPaused = false;
    }

    handleVisibilityChange() {
      if (document.hidden) {
        this.isPaused = true;
      } else {
        this.isPaused = false;
      }
    }

    next() {
      if (this.isAnimating) return;
      this.isAnimating = true;

      const currentSlide = this.slides[this.currentIndex];
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      const nextSlide = this.slides[nextIndex];

      // 1. Le slide actuel sort par la gauche
      currentSlide.classList.remove('is-active');
      currentSlide.classList.add('is-leaving');
      currentSlide.setAttribute('aria-hidden', 'true');
      if (currentSlide.tagName === 'A') currentSlide.setAttribute('tabindex', '-1');

      // 2. Le prochain slide entre par la droite
      nextSlide.classList.add('is-active');
      nextSlide.removeAttribute('aria-hidden');
      if (nextSlide.tagName === 'A') nextSlide.removeAttribute('tabindex');

      // 3. Cleanup après l'animation
      setTimeout(() => {
        currentSlide.classList.remove('is-leaving');
        this.currentIndex = nextIndex;
        this.isAnimating = false;
      }, 600);
    }
  }

  customElements.define('incipit-bar-slider', IncipitBarSlider);
}